/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AgentsResponse,
  HTTPValidationError,
} from '../models/index';
import {
    AgentsResponseFromJSON,
    AgentsResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface GetAgentsApiV1AgentsGetRequest {
    source?: GetAgentsApiV1AgentsGetSourceEnum;
}

/**
 * 
 */
export class AgentsApi extends runtime.BaseAPI {

    /**
     * Get the list of agents available to the authenticated user.  The returned agents are filtered by the user\'s Guardian role: - Internal (Scality) users receive all available agents. - External users receive only the agents accessible to their role.  Agents marked `only_preprod` are excluded when the application runs in PROD.  Args:     current_user: Authenticated user information  Returns:     AgentsResponse: List of agents the user can select in the chat interface
     * Get Agents
     */
    async getAgentsApiV1AgentsGetRaw(requestParameters: GetAgentsApiV1AgentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AgentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/agents/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AgentsResponseFromJSON(jsonValue));
    }

    /**
     * Get the list of agents available to the authenticated user.  The returned agents are filtered by the user\'s Guardian role: - Internal (Scality) users receive all available agents. - External users receive only the agents accessible to their role.  Agents marked `only_preprod` are excluded when the application runs in PROD.  Args:     current_user: Authenticated user information  Returns:     AgentsResponse: List of agents the user can select in the chat interface
     * Get Agents
     */
    async getAgentsApiV1AgentsGet(requestParameters: GetAgentsApiV1AgentsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AgentsResponse> {
        const response = await this.getAgentsApiV1AgentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAgentsApiV1AgentsGetSourceEnum = {
    Portal: 'portal',
    ArtescaUi: 'artesca_ui',
    CustomerPortal: 'customer_portal',
    RingUi: 'ring_ui',
    AdiUi: 'adi_ui'
} as const;
export type GetAgentsApiV1AgentsGetSourceEnum = typeof GetAgentsApiV1AgentsGetSourceEnum[keyof typeof GetAgentsApiV1AgentsGetSourceEnum];
